import { flattenFilterArrays } from '@/components/regionen/pageRegionSlug/Map/SourcesAndLayers/utils/filterUtils/flattenFilterArrays'
import { wrapFilterWithAll } from '@/components/regionen/pageRegionSlug/Map/SourcesAndLayers/utils/filterUtils/wrapFilterWithAll'
import type { SourcesId } from '../../../mapDataSources/sources.const'
import type { FileMapDataSubcategoryStyleLayer } from '../../../types'
import type { StyleLayer } from './types'

export type WrapSourceLayersProps = {
  layers: StyleLayer[]
  source: SourcesId
  sourceLayer: string
  idPrefix?: string
  interactive?: false
  minzoom?: number
  maxzoom?: number
  additionalFilter?:
    | ['match', ['get', string], string[], boolean, boolean]
    | ['has', string]
    | ['==', '$type', 'Polygon' | 'Point' | 'LineString']
}

/** @desc Takes layers that hold just the style information and adds the source-information. It also allows to use the same layers with different `additionalFilter`. */
export const wrapSourceLayers = ({
  layers,
  source,
  sourceLayer,
  idPrefix,
  interactive,
  minzoom,
  maxzoom,
  additionalFilter,
}: WrapSourceLayersProps) => {
  return layers.map((layer) => {
    const layerFilter = layer.filter as unknown[] | undefined
    return {
      ...layer,
      source,
      'source-layer': sourceLayer,
      id: [idPrefix, layer.id].filter(Boolean).join('--'),
      ...(interactive !== undefined ? { interactive } : {}),
      filter: additionalFilter
        ? wrapFilterWithAll(flattenFilterArrays(layerFilter, additionalFilter))
        : layer.filter,
      ...(minzoom !== undefined ? { minzoom } : {}),
      ...(maxzoom !== undefined ? { maxzoom } : {}),
    }
  }) satisfies FileMapDataSubcategoryStyleLayer[]
}
